// extracted by mini-css-extract-plugin
export default {"contract-signature":"styles_contract-signature__9m1fl"};